<template>
  <div class="page">
    <div class="banners">
      <img src="../assets/img/about/welfare_banner.jpg" alt="公益动态" />
    </div>
    <div class="news">
      <div class="wrap" id="d-top">
        <div class="swiper-container news-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide"  v-for="(item, index) in list" :key="index" >
              <div class="box-wrap">
                <div class="img-wrap">
                  <img :src="'../storage/'+item.cover" alt="" />
                </div>
                <div class="content-wrap">
                  <div class="title">
                    <h4>{{item.title}}</h4>
                  </div>
                  <div class="content">
                    <p>
                      {{item.summary}}
                    </p>
                  </div>
                  <div class="btn-wrap">
                    <button @click="todetail(item.id)">查看详情</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div class="more-content" v-if="welfaresList">
          <div v-for="(item, index) in welfaresList" :key="index" class="news-item">
            <div class="box-wrap">
              <div class="img-wrap">
                <img :src="'../storage/'+item.cover" alt="" />
              </div>
              <div class="content-wrap">
                <div class="title">
                  <h4>{{item.title}}</h4>
                </div>
                <div class="content">
                  <p>
                    {{item.summary}}
                  </p>
                </div>
                <div class="btn-wrap">
                  <button @click="todetail(item.id)">查看详情</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="more-div" v-show="showMore">
          <span @click="getMoreNews">查看更多 -></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "welfare",
  data() {
    return {
      list: [],
      load: 1,
      curr_page: 1,
      pages: "8",
      bannerUrl: null,
      welfaresList:[],
      last_page:1,
    };
  },
  computed: {
      showMore: function() {
          return this.curr_page < this.last_page ? true : false ;
      }
  },
  created(){
    this.getList();
    // let that = this;
    // this.$ajax.post("/banners/" + this.pages)
    //   .then(function (res) {
    //     console.log( res );
    //     that.bannerArr = res.banners[0].imgurl;
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  mounted() {
    this.init();

  },
  methods: {
    init() {
      var swiper = new Swiper(".swiper-container", {
        pagination: ".swiper-pagination",
        autoplay: 5000,
        autoplayDisableOnInteraction: false,
        observer:true,
        observeParents:true,
        // spaceBetween: 42,
      });
    },
    todetail: function (id) {
      this.$router.push("/welfaredetail/" + id);
    },
    //获取新闻列表数据
    getList() {
      let that = this;
      this.$ajax
        .get("/getWelfareList", {
          params: {
            page: that.curr_page,
          },
        })
        .then((res) => {
          that.list = res.list.data;
          that.last_page = res.list.last_page;

        })
        .catch((error) => {
          // console.log(error);
        });
    },
    getMoreNews(){
      let that = this;
      if( this.curr_page < this.last_page ) this.curr_page ++;
      this.$ajax
        .get("/getWelfareList", {
          params: {
            page: this.curr_page,
          },
        })
        .then((res) => {
          let list = res.list.data;
          for (let i in list) {
            that.welfaresList.push(list[i]);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    }
  },
};
</script>

<style lang="scss">
@import "../assets/css/function";
@import "../assets/css/global";

.news {
  padding: 1rem 0;
  h4{
    font-size: 1.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .wrap{
    .news-swiper{
      height: 450px;
    }
  }
  .more-div {
    position: relative;
    padding: 1rem 0;
    text-align: center;
    color: #999;
    margin: 0 auto;
  }
  .more-content{
    .news-item{
      margin: 1rem 0;
    }
  }
  .box-wrap {
    width: 320px;
    border-radius: 20px;
    margin: 0 auto;
    box-shadow: 0 0 5px #999;
    padding-bottom: 2rem;
    .img-wrap{
      img{
        height: 200px;
        border-radius: 1rem 1rem 0 0;
      }
    }
    .content-wrap{
      .title{
        padding: .5rem 1rem .5rem 1rem;
        border-bottom: 1px solid rgb(245, 245, 245);
      }
      .content{
        padding: 1rem;
        p{
          height: 2.4rem;
          font-size: .8rem;
          line-height: 1.2rem;
          overflow:hidden;
          text-overflow:ellipsis;
          white-space: normal;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;/*规定最多显示两行*/
        }
      }
      .btn-wrap{
        display: flex;
        justify-content: center;
        button{
          width: 80%;
          height: 3rem;
          border-radius: 2rem;
          background-color: #fff;
          border: 1px solid rgb(178, 16, 16);
          color: rgb(178, 16, 16);
        }
      }
    }
  }
  .swiper-pagination-bullet{
  width: .8rem;
  height: .8rem;
  background: rgb(178, 16, 16);
  opacity: .3;
}
.swiper-pagination-bullet-active{
  background: rgb(178, 16, 16);
  opacity: 1;
}
}



</style>



// WEBPACK FOOTER //
// src/page/welfare.vue